// import React from 'react';
// import { 
//   DollarSign, ShieldCheck, Scale, Award, 
//   ChevronLeft, Clock, Calendar, Check, 
//   HelpCircle, CreditCard, Info 
// } from 'lucide-react'; // run: npm i lucide-react

// export default function PriceListAndFees() {
  
//   // Dynamic Pricing Tiers Matrix
//   const pricingModels = [
//     {
//       title: "الاستشارات الفورية والشركات الناشئة",
//       priceType: "أتعاب ثابتة للمشروع",
//       desc: "مناسب للمشاريع محددة النطاق مسبقاً، مثل صياغة عقد معين، تسجيل علامة تجارية، أو تقديم استشارة مكتوبة تفصيلية.",
//       features: [
//         "وضوح مالي كامل قبل البدء بالعمل",
//         "تغطية شاملة للمراجعات والتعديلات المتفق عليها",
//         "تسليم التقارير القانونية بصيغة رقمية معتمدة"
//       ],
//       badge: "الخيار الأكثر شفافية"
//     },
//     {
//       title: "الاشتراكات السنوية (المستشار الخارجي)",
//       priceType: "باقات شهرية / سنوية",
//       desc: "مصمم خصيصاً للشركات والمؤسسات لضمان توفر غطاء قانوني مستمر يغطي الأعمال اليومية، مراجعة العقود، وحضور الاجتماعات.",
//       features: [
//         "ساعات استشارية مرنة ومخصصة شهرياً",
//         "أولوية مطلقة في الرد والمعالجة الطارئة",
//         "خصومات حصرية على الترافع والتمثيل القضائي"
//       ],
//       badge: "الأكثر طلباً للشركات",
//       highlight: true
//     },
//     {
//       title: "القضايا المعقدة والمنازعات الكبرى",
//       priceType: "نظام الساعات / أتعاب النجاح",
//       desc: "يُعتمد في القضايا التجارية الكبرى، إجراءات الإفلاس، أو التركات المعقدة التي يصعب تحديد مداها الزمني مسبقاً.",
//       features: [
//         "كشوفات شفافة بساعات العمل الفعلية للمستشارين",
//         "ربط جزء من الأتعاب بتحقيق نتائج مستهدفة (أتعاب نجاح)",
//         "تقارير دورية تبيّن الموقف الإجرائي والمالي للملف"
//       ],
//       badge: "للمنازعات الاستراتيجية"
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
      
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">الشفافية المالية أساس علاقتنا المهنية المستدامة</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">سياسة الأتعاب وهيكلة الأجور القانونية</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نؤمن في مكتبنا بأن الوضوح المالي يبني جسور الثقة مع عملائنا. نعتمد معايير تسعير مرنة وعادلة تخضع للحوكمة، وتضمن حصولك على أعلى مستويات الجودة القانونية دون مفاجآت مالية غير متوقعة.
//           </p>
//         </div>
//       </section>

//       {/* Analytical Value Propositon Breakdown */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               كيف نحدد القيمة السعرية للخدمة الاستشارية؟
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               لا نقوم بفرض تكاليف نمطية؛ بل نلزم مستشارينا بدراسة وتحليل طبيعة كل ملف بشكل مستقل خلال الجلسة التمهيدية. يتم تقييم حجم المخاطر، الأثر المالي، الخبرات التخصصية المطلوبة، والمدد الزمنية المتوقعة للوصول إلى الهيكل السعري الأعدل لك.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               كل اتفاقية أتعاب نبرمها تصدر مصحوبة بملحق تفصيلي يوضح نطاق العمل بدقة (Scope of Work)، والالتزامات المتبادلة، ومواعيد الاستحقاق المرتبطة بالمخرجات التنفيذية الفعليّة، مما يمنح إدارتك المالية القدرة على التخطيط وضبط الميزانيات بدقة.
//             </p>
//           </div>
          
//           {/* Core Guarantees Checklist Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <ShieldCheck className="w-5 h-5" /> ركائز السياسة المالية للمكتب:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <Check className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إصدار فواتير ضريبية نظامية مفصلة متوافقة مع (ZATCA).</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Check className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>الفصل التام بين أتعاب المحاماة والرسوم الحكومية الخارجية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Check className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إخطار العميل مسبقاً وبشكل مكتوب بأي مصاريف طارئة للموافقة عليها.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Check className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>إتاحة خيارات جدولة مرنة للأتعاب على دفعات مرحلية وميسرة.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Pricing Tier Architecture */}
//       <section className="max-w-6xl mx-auto py-12 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">نماذج التعاقد المالي المعتمدة</h2>
//           <p className="text-gray-500">اختر الهيكل التمويلي القانوني الأكثر ملاءمة لحجم عمليات منشأتك واحتياجاتها</p>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
//           {pricingModels.map((model, index) => (
//             <div 
//               key={index} 
//               className={`bg-white rounded-2xl border transition-all duration-300 flex flex-col justify-between overflow-hidden relative ${
//                 model.highlight ? 'border-amber-500 shadow-md ring-1 ring-amber-500/30' : 'border-gray-100 shadow-sm hover:border-gray-300'
//               }`}
//             >
//               {/* Dynamic Badging */}
//               <div className="p-6 md:p-8">
//                 <span className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full mb-4 ${
//                   model.highlight ? 'bg-amber-100 text-amber-800' : 'bg-slate-100 text-slate-800'
//                 }`}>
//                   {model.badge}
//                 </span>
//                 <h3 className="text-xl font-bold text-slate-800 mb-1">{model.title}</h3>
//                 <h4 className="text-amber-600 font-medium text-sm mb-4">{model.priceType}</h4>
//                 <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-6">{model.desc}</p>
                
//                 <hr className="border-gray-100 mb-6" />
                
//                 <ul className="space-y-3">
//                   {model.features.map((feature, idx) => (
//                     <li key={idx} className="flex gap-2.5 items-start text-xs md:text-sm text-gray-600">
//                       <Check className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
//                       <span>{feature}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>

//               <div className="p-6 bg-slate-50 border-t border-gray-100 text-center">
//                 <button className={`w-full font-medium text-xs md:text-sm py-3 rounded-lg transition-colors flex items-center justify-center gap-2 ${
//                   model.highlight ? 'bg-amber-600 text-white hover:bg-amber-700' : 'bg-slate-800 text-white hover:bg-slate-900'
//                 }`}>
//                   طلب دراسة وتسعير ملفك القانوني
//                   <ChevronLeft className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Transparency Note regarding Out-of-Pocket Expenses */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <Info className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">توضيح بخصوص المصاريف الخارجية (Out-of-Pocket Expenses):</h4>
//             <p className="text-amber-950 text-xs md:text-sm leading-relaxed">
//               يرجى العلم بأن أتعاب الاستشارات والتمثيل المذكورة في العقود لا تشمل الرسوم الحكومية (مثل رسوم إيداع براءات الاختراع، قيد الشركات، رسوم التقاضي الرسمية أمام وزارة العدل)، ولا تشمل أجور المطورين أو المترجمين المعتمدين أو المقيمين. يتم سداد هذه الرسوم مباشرة من قبل العميل أو دفعها عبر حساب الأمانات الخاص بالمكتب بموجب فواتير وسندات رسمية مستقلة.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Active Lead Gen Conversion / Payment Security */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <CreditCard className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل ترغب في الحصول على عرض سعر مخصص لنشاطك؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           يسعدنا استقبال تفاصيل قضيتك أو نطاق العمل المطلوب لشركتك في سرّية تامة، ليقوم مستشارونا بإعداد تحليل متكامل وعرض مالي واضح يتناسب مع تطلعاتك وميزانيتك.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب عرض سعر مخصص ومغلق
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );

// }



import React from 'react';
import {
  DollarSign,
  ShieldCheck,
  Scale,
  Award,
  ChevronLeft,
  Clock,
  Calendar,
  Check,
  HelpCircle,
  CreditCard,
  Info
} from 'lucide-react';

export default function PriceListAndFees() {

  // =========================
  // WhatsApp Logic
  // =========================
  const whatsappNumber = "966564930437"; // <-- your WhatsApp number

  const openWhatsApp = (serviceTitle) => {
    const message = `
السلام عليكم،

أرغب بالحصول على عرض سعر للخدمة التالية:

${serviceTitle}

تم الإرسال من صفحة:
سياسة الأتعاب وهيكلة الأجور القانونية
    `;

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  };

  // =========================
  // Pricing Models
  // =========================
  const pricingModels = [
    {
      title: "الاستشارات الفورية والشركات الناشئة",
      priceType: "أتعاب ثابتة للمشروع",
      desc:
        "مناسب للمشاريع محددة النطاق مسبقاً، مثل صياغة عقد معين، تسجيل علامة تجارية، أو تقديم استشارة مكتوبة تفصيلية.",
      features: [
        "وضوح مالي كامل قبل البدء بالعمل",
        "تغطية شاملة للمراجعات والتعديلات المتفق عليها",
        "تسليم التقارير القانونية بصيغة رقمية معتمدة"
      ],
      badge: "الخيار الأكثر شفافية"
    },
    {
      title: "الاشتراكات السنوية (المستشار الخارجي)",
      priceType: "باقات شهرية / سنوية",
      desc:
        "مصمم خصيصاً للشركات والمؤسسات لضمان توفر غطاء قانوني مستمر يغطي الأعمال اليومية، مراجعة العقود، وحضور الاجتماعات.",
      features: [
        "ساعات استشارية مرنة ومخصصة شهرياً",
        "أولوية مطلقة في الرد والمعالجة الطارئة",
        "خصومات حصرية على الترافع والتمثيل القضائي"
      ],
      badge: "الأكثر طلباً للشركات",
      highlight: true
    },
    {
      title: "القضايا المعقدة والمنازعات الكبرى",
      priceType: "نظام الساعات / أتعاب النجاح",
      desc:
        "يُعتمد في القضايا التجارية الكبرى، إجراءات الإفلاس، أو التركات المعقدة التي يصعب تحديد مداها الزمني مسبقاً.",
      features: [
        "كشوفات شفافة بساعات العمل الفعلية للمستشارين",
        "ربط جزء من الأتعاب بتحقيق نتائج مستهدفة (أتعاب نجاح)",
        "تقارير دورية تبيّن الموقف الإجرائي والمالي للملف"
      ],
      badge: "للمنازعات الاستراتيجية"
    }
  ];

  return (
    <div className="bg-slate-50 text-right font-sans" dir="rtl">

      {/* Hero Header Section */}
      <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>

        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">
            الشفافية المالية أساس علاقتنا المهنية المستدامة
          </span>

          <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">
            سياسة الأتعاب وهيكلة الأجور القانونية
          </h1>

          <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
            نؤمن في مكتبنا بأن الوضوح المالي يبني جسور الثقة مع عملائنا.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="max-w-6xl mx-auto py-12 px-4">

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">

          {pricingModels.map((model, index) => (

            <div
              key={index}
              className={`bg-white rounded-2xl border transition-all duration-300 flex flex-col justify-between overflow-hidden relative ${
                model.highlight
                  ? 'border-amber-500 shadow-md ring-1 ring-amber-500/30'
                  : 'border-gray-100 shadow-sm hover:border-gray-300'
              }`}
            >

              <div className="p-6 md:p-8">

                <span
                  className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full mb-4 ${
                    model.highlight
                      ? 'bg-amber-100 text-amber-800'
                      : 'bg-slate-100 text-slate-800'
                  }`}
                >
                  {model.badge}
                </span>

                <h3 className="text-xl font-bold text-slate-800 mb-1">
                  {model.title}
                </h3>

                <h4 className="text-amber-600 font-medium text-sm mb-4">
                  {model.priceType}
                </h4>

                <p className="text-gray-500 text-xs md:text-sm leading-relaxed mb-6">
                  {model.desc}
                </p>

                <hr className="border-gray-100 mb-6" />

                <ul className="space-y-3">
                  {model.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className="flex gap-2.5 items-start text-xs md:text-sm text-gray-600"
                    >
                      <Check className="w-4 h-4 text-amber-600 shrink-0 mt-0.5" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* WhatsApp Button */}
              <div className="p-6 bg-slate-50 border-t border-gray-100 text-center">

                <button
                  onClick={() => openWhatsApp(model.title)}
                  className={`w-full font-medium text-xs md:text-sm py-3 rounded-lg transition-colors flex items-center justify-center gap-2 ${
                    model.highlight
                      ? 'bg-amber-600 text-white hover:bg-amber-700'
                      : 'bg-slate-800 text-white hover:bg-slate-900'
                  }`}
                >
                  طلب دراسة وتسعير ملفك القانوني

                  <ChevronLeft className="w-4 h-4" />
                </button>

              </div>
            </div>

          ))}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">

        <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
          <CreditCard className="w-6 h-6" />
        </div>

        <h3 className="text-xl font-bold text-slate-800 mb-2">
          هل ترغب في الحصول على عرض سعر مخصص لنشاطك؟
        </h3>

        <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
          يسعدنا استقبال تفاصيل قضيتك أو نطاق العمل المطلوب لشركتك.
        </p>

        {/* General WhatsApp CTA */}
        <button
          onClick={() => openWhatsApp("طلب عرض سعر مخصص")}
          className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2"
        >
          طلب عرض سعر مخصص ومغلق

          <ChevronLeft className="w-4 h-4" />
        </button>

      </section>
    </div>
  );
}



















